import React, { useEffect, useRef, useState } from 'react';

import { useTranslation } from '@wix/yoshi-flow-editor';
import { useSidebarLayoutBase } from '../contexts/SidebarLayoutBase/SidebarLayoutBaseContext';
import { useChatSDK } from '../../../../../../hooks/userChatSDK';
import {
  Button,
  ButtonPriority,
  ButtonSize,
  HoverStyles,
  SkeletonLine,
  Text,
  TextField,
  TextFieldTheme,
  TextPriority,
  TextTypography,
} from 'wix-ui-tpa/cssVars';
import { ChatMessageData } from '@wix/chat-widget-ui-lib';
import { SendFill } from '@wix/wix-ui-icons-common/on-stage';

import { classes } from '../SidebarLayoutForParticipant.st.css';

export default () => {
  const { t } = useTranslation();
  const { isAiChatEnabled } = useSidebarLayoutBase();
  const {
    conversationMessages,
    sendMessage,
    initConversation,
    // widgets,
    // onWidgetAction,
    newConversation,
    isPending,
  } = useChatSDK();
  const [newMessage, setNewMessage] = useState<string>('');
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    void initConversation();
  }, []);

  useEffect(() => {
    if (bottomRef?.current) {
      bottomRef.current.scrollIntoView?.({
        behavior: 'smooth',
        block: 'end',
      });
    }
  }, [bottomRef?.current, conversationMessages]);

  if (!isAiChatEnabled) {
    return null;
  }

  return (
    <>
      <Text
        tagName="h3"
        typography={TextTypography.smallTitle}
        priority={TextPriority.primary}
      >
        {t('live-site.ai-chat.title')}
      </Text>

      {isPending ? (
        <ul className={classes.skeleton}>
          <SkeletonLine />
          <SkeletonLine />
          <SkeletonLine />
        </ul>
      ) : (
        <>
          <ul className={classes.messagesList}>
            {(conversationMessages || []).map((message: ChatMessageData) => {
              return (
                <li
                  key={message.id}
                  className={`${classes.message} ${
                    message.role === 'assistant' ? classes.assistantMessage : ''
                  }`}
                >
                  <Text priority={TextPriority.primary}>
                    {(message as any).status === 'loading'
                      ? '...'
                      : message.content}
                  </Text>
                </li>
              );
            })}
          </ul>
          <form
            className={classes.messageForm}
            onSubmit={(e) => {
              void sendMessage(newMessage);
              setNewMessage('');

              e.preventDefault();
            }}
          >
            <TextField
              theme={TextFieldTheme.Line}
              placeholder="New Message"
              suffix={<SendFill />}
              value={newMessage}
              onChange={(e) => {
                setNewMessage(e.target.value);
              }}
            />
            {conversationMessages?.length > 2 ? (
              <Button
                priority={ButtonPriority.secondary}
                size={ButtonSize.tiny}
                hoverStyle={HoverStyles.underline}
                onClick={() => newConversation()}
                fullWidth={true}
              >
                Start New Conversation
              </Button>
            ) : null}
          </form>
          <div ref={bottomRef} />
        </>
      )}
    </>
  );
};
